// @ts-nocheck
import React, { useContext, useEffect, useState } from 'react'
import { inject, observer } from 'mobx-react'

import { useStores } from 'hooks/useStores'

import Skeleton from '../components/Skeleton'
import { codeToLocale, getLocaleStr, getTenantInfo } from '../utils/utils'
import { Page } from 'utils/constants'
import queryString from 'query-string'
import { StoreContext } from '../contexts/StoreContext'
import MenuGrid from '../components/menu/MenuGrid'
import LoadingSpinner from '../components/common/LoadingSpinner'

const MenuMobile = inject(
	'Infra',
	'User'
)(
	observer((props) => {
		const { courseList, mode, ais, app } = queryString.parse(window.location.search)
		const { store } = useContext(StoreContext)
		const { Infra, User } = props
		const rest = store?.data
		const [isMenuReady, setIsMenuReady] = useState(false)
		const { addressManagerV2Store } = useStores()

		useEffect(() => {
			const newUrl = window.location.search
			const tenantId = getTenantInfo()
			if (!newUrl.includes(`showMenu_${tenantId}`) && !newUrl.includes(`j=${tenantId}`)) {
				addressManagerV2Store.storeMenuUrlToLS(newUrl)
			}
		}, [])

		useEffect(() => {
			if (store?.data) {
				setIsMenuReady(true)
			}
		}, [store?.data])

		if (!isMenuReady) {
			return (
				<div
					style={{
						width: '100vw',
						height: '100vh',
						display: 'flex',
						flexFlow: 'row nowrap',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<LoadingSpinner chainId={Infra.appParams?.c} brand={Infra.appParams.brand} />
				</div>
			)
		}

		if (rest && rest.name) {
			return (
				<Skeleton
					page={Page.MENU}
					showSideMenu={props.showSideMenu}
					showCart
					title={getLocaleStr(rest?.name, User.preferredLanguage ? codeToLocale[User.preferredLanguage] : rest.locale)}
					showSearch={false}
					showCustomMessage={false}
					showLogo
					showMenuTabs
					showPaymentMessage
					showHeader
					logoURL={rest?.picture}
					showStoreInfo
					hideNavigation
				>
					<MenuGrid courseList={courseList} mode={mode} ais={ais} app={app} />
				</Skeleton>
			)
		}
		return null
	})
)

export default MenuMobile
